import { render, staticRenderFns } from "./voucherOrder.vue?vue&type=template&id=0467fea2&scoped=true&"
import script from "./voucherOrder.vue?vue&type=script&lang=js&"
export * from "./voucherOrder.vue?vue&type=script&lang=js&"
import style0 from "./voucherOrder.vue?vue&type=style&index=0&id=0467fea2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0467fea2",
  null
  
)

export default component.exports